import Vue from 'vue'
import './plugins/axios'
Vue.config.devtools = true

import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'

Vue.config.productionTip = false

Vue.use(Vuelidate)

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')